import { useEffect, useRef, type ReactNode } from 'react';
import './modal.css';

/**
 * Fenster über der Seite für Inhalt, der nicht in die Karte passt, zum Beispiel die ganze Liste hinter einer Auswertung. Es ist ein echtes Dialogfenster: Der Fokus bleibt darin, Escape und ein Klick
 * auf den abgedunkelten Rand schließen es, danach kehrt der Fokus zur Schaltfläche zurück. Der Inhalt wird erst beim Öffnen aufgebaut.
 */
export function Modal({ open, title, onClose, children, wide = false }: { open: boolean; title: string; onClose: () => void; children: ReactNode; wide?: boolean }) {
  const dialog = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const el = dialog.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    if (!open && el.open) el.close();
  }, [open]);

  return (
    <dialog
      ref={dialog}
      className={`modal${wide ? ' modal--wide' : ''}`}
      aria-labelledby="modal-title"
      onClose={onClose}
      onClick={(e) => {
        if (e.target === dialog.current) onClose();
      }}
    >
      {open && (
        <div className="modal__box">
          <header className="modal__head">
            <h2 id="modal-title">{title}</h2>
            <button type="button" className="modal__close" onClick={onClose} aria-label="Schließen">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
          </header>
          <div className="modal__body">{children}</div>
        </div>
      )}
    </dialog>
  );
}
